/* global $ */
import angular from 'angular';
import ComponentsModule from '../components-module';
import _ from 'lodash';
import template from './search-field.html';
import Debug from 'ace-ui/ace-debug';

const COMPONENT_NAME = 'searchField';
const debug = new Debug (COMPONENT_NAME);

/**
 * Search field directive where you can search for content.
 */
angular.module (ComponentsModule)
  .directive (COMPONENT_NAME, function SearchFieldDirective ($rootScope, $location, $route, $timeout, $translate,
    SearchService, ClipboardService, ContentCardService, ContentEditor, KeyboardShortcutService) {

    const KeyboardKeys = Object.freeze({
      KEY_BACKSPACE: 8,
      KEY_ENTER: 13,
      KEY_ESCAPE: 27,
      KEY_UP: 38,
      KEY_DOWN: 40
    });

    return {
      restrict: 'AE',
      replace: true,

      scope: {
        filterByType: '<'
      },

      template,

      controller: function ($scope, $element) {
        $scope.selectedIndex = -1;
        $scope.searchString = '';
        $scope.searchResults = [];

        $scope.UiStates = {
          Idle: 'Idle',
          Active: 'Active',
          Searching: 'Searching',
          Hidden: 'Hidden'
        };

        $scope.ResultStates = {
          Initial: 'Initial',
          HasResult: 'HasResult',
          Error: 'Error'
        };

        $scope.uiState = $scope.UiStates.Idle;
        $scope.resultState = $scope.ResultStates.Initial;

        var previousSearchString = undefined;

        // We clear search state on logout
        $rootScope.$on('aceui:userLoggedOut', function () {
          $scope.searchResults = [];
          $scope.searchString = '';
          $scope.uiState = $scope.UiStates.Idle;
        });

        $scope.setMouseSelectionMode = (event) => {
          $($element).one('keydown', $scope.setKeyboardSelectionMode);
          $scope.selectionMode = 'msm';
          $(event.target).trigger('mouseover');
        };

        $scope.setKeyboardSelectionMode = () => {
          $($element).one('mousemove', $scope.setMouseSelectionMode);
          $scope.selectionMode = 'ksm';
        };

        $scope.onHover = (index) => {
          if ($scope.selectionMode === 'msm') {
            $scope.selectedIndex = index;
          }
        };

        $scope.focus = function () {
          $scope.uiState = $scope.UiStates.Active;
        };

        var isKeepOverlayOpen = false;
        $scope.keepOverlayOpen = function (keepOverlayOpen) {
          isKeepOverlayOpen = keepOverlayOpen;
        };

        $scope.blur = function () {
          if (!isKeepOverlayOpen) {
            $scope.uiState = $scope.uiState === $scope.UiStates.Hidden ? $scope.UiStates.Hidden : $scope.UiStates.Idle;
            $scope.selectedIndex = -1;
          }
        };

        $scope.toSearchView = function (searchString) {
          $scope.keepOverlayOpen(false);
          $scope.uiState = $scope.UiStates.Hidden;

          var oldPath = $location.url();
          var newPath = '/search?q=' + searchString;

          if (oldPath == newPath) {
            $route.reload();
          } else {
            $location.url('/search?q=' + searchString);
          }
        };

        $scope.open = function ($event, searchEntry) {
          if (isKeepOverlayOpen) {
            $scope.keepOverlayOpen(false);
            $scope.uiState = $scope.UiStates.Idle;
          }

          $scope.selectedIndex = -1;
          ContentEditor.openContent(searchEntry.id);
        };

        $scope.copy = function (event, searchEntry) {
          $(event.currentTarget).blur();

          event.stopPropagation();
          event.preventDefault();

          $(event.currentTarget).closest('.search-field').find('input[type=search]').focus();
          $scope.keepOverlayOpen(false);

          ClipboardService.putInClipboard([
            {
              id: searchEntry.alias,
              type: searchEntry.contentType.value
            }
          ]).catch(function (error) {
            console.warn('Error: Failed to insert content reference(s) into clipboard!', error);

            $(event.target).attr('title', $translate.instant('search-field.copy.copy-failed.title'));
            $(event.target).tooltip({ 'trigger': 'manual', 'container': 'body' });
            $(event.target).tooltip('show');

            setTimeout(function () {
              $(event.target).tooltip('destroy');
            }, 2000);
          });
        };

        var isVisible = function (element) {
          var searchResultsElement = $('.search-results');

          return element.position().top + element.outerHeight() < searchResultsElement.height()
          && element.position().top > 0;
        };

        var selectNextSearchEntry = function (currentlySelectedEntry) {
          var currentlySelectedElement = angular.element('*[data-id="' + currentlySelectedEntry.id + '"]');
          var nextElement = currentlySelectedElement.next();

          if (nextElement.length && !isVisible(nextElement)) {
            nextElement.get(0).scrollIntoView(false);
          }
        };

        var selectPreviousEntry = function (currentlySelectedEntry) {
          var elementToSelect = undefined;

          if ($scope.selectedIndex > 0) {
            var currentlySelectedElement = angular.element('*[data-id="' + currentlySelectedEntry.id + '"]');
            elementToSelect = currentlySelectedElement.prev();
          } else {
            elementToSelect = angular.element('.show-all');
          }

          if (elementToSelect.length && !isVisible(elementToSelect)) {
            elementToSelect.get(0).scrollIntoView();
          }
        };

        var resetScroll = function () {
          var fullSearchResultsElement = angular.element('.show-all');

          if (fullSearchResultsElement.length && !isVisible(fullSearchResultsElement)) {
            fullSearchResultsElement.get(0).scrollIntoView();
          }
        };

        $scope.handleKeys = function ($event) {
          var inputElement = $($event.target);

          if ($event.keyCode === KeyboardKeys.KEY_ENTER && $scope.selectedIndex === -1 && $scope.searchString !== '') {
            $scope.uiState = $scope.UiStates.Hidden;
            $scope.toSearchView($scope.searchString);
            inputElement.blur();
          } else if ($event.keyCode === KeyboardKeys.KEY_ENTER && $scope.searchResults.length) {
            if ($scope.selectedIndex !== -1) {
              $scope.open(null, $scope.searchResults[$scope.selectedIndex]);
              inputElement.blur();
            }
          } else if ($event.keyCode === KeyboardKeys.KEY_UP && $scope.searchResults.length) {
            selectPreviousEntry($scope.searchResults[Math.min($scope.selectedIndex, $scope.searchResults.length - 1)]);
            $scope.selectedIndex = Math.max(--$scope.selectedIndex, -1);
          } else if ($event.keyCode === KeyboardKeys.KEY_DOWN && $scope.searchResults.length) {
            selectNextSearchEntry($scope.searchResults[Math.max($scope.selectedIndex, 0)]);
            $scope.selectedIndex = Math.min(++$scope.selectedIndex, $scope.searchResults.length - 1);
          } else if ($event.keyCode === KeyboardKeys.KEY_ESCAPE) {
            $scope.searchString = '';
            $scope.selectedIndex = -1;
            $scope.searchResults = [];

            previousSearchString = null;

            $scope.resultState = $scope.ResultStates.Initial;
            $scope.uiState = $scope.UiStates.Idle;

            inputElement.blur();
          }
        };

        var searchRequestCounter = 0;

        var doSearch = _.debounce (function () {
          if (!$scope.searchString) {
            $scope.searchResults = [];
            $scope.resultState = $scope.ResultStates.Initial;
            $scope.$apply();
          } else if ($scope.searchString !== previousSearchString) {
            previousSearchString = $scope.searchString;

            var requestCounter = ++searchRequestCounter;
            var tempSearchResults = [];

            $scope.uiState = $scope.uiState === $scope.UiStates.Hidden ? $scope.UiStates.Hidden : $scope.UiStates.Searching;

            var searchString = ($scope.searchString === '' ? '*:*' : $scope.searchString + ' OR ' + $scope.searchString + '*');
            var filterQueries = $scope.filterByType.length > 0 ? ['ace_type_s:(' + $scope.filterByType.join(' OR ') + ')'] : [];

            var queryObject = {
              variant: 'aceUISearch',
              params: {
                q: searchString,
                rows: 50,
                fq: filterQueries,
                qt: 'freetextSearch'
              }
            };

            SearchService.search (queryObject)
              .then ((searchResponse) => {
                if (requestCounter !== searchRequestCounter || !$scope.searchString) {
                  return; // overlapping request...
                }

                var searchDocuments = atex.aceui.ObjectUtils.getByPath(searchResponse, 'response/docs') || [];

                searchDocuments.forEach(function (doc) {

                  const result = ContentCardService.fromAceUISearch (doc._content);

                  let searchResultEntry = { id: result.alias };
                  let contentType = result.contentType.label || result.contentType.value;

                  searchResultEntry.contentCard = result.getContextual ({ contentType: { label:  contentType }, thumbnail: { aspectRatio: '1:1', width: 55 } }, 'LIST', 'SEARCH-DROPDOWN', { thumbnail: { collapse: true }});
                  delete searchResultEntry.contentCard.datetime;

                  ContentCardService.resolveThumbnail (searchResultEntry.contentCard.thumbnail)
                    .then (thumbnail => { searchResultEntry.contentCard.thumbnail = thumbnail; }) ;

                  if (requestCounter === searchRequestCounter) {
                    tempSearchResults.push(searchResultEntry);
                  }
                });
                $scope.searchResults = tempSearchResults;
                $scope.selectedIndex = -1;
                $scope.showingMsg =
                $translate.instant ('search-field.status.showing.text', { $1: tempSearchResults.length, $2: atex.aceui.ObjectUtils.getByPath(searchResponse, 'response/numFound') });

                $scope.uiState = $scope.uiState === $scope.UiStates.Hidden ? $scope.UiStates.Hidden : $scope.UiStates.Active;
                $scope.resultState = $scope.ResultStates.HasResult;

                resetScroll();
              })
              .catch ((error) => {
                console.warn('Error while searching!', error);

                $scope.uiState = $scope.UiStates.Active;
                $scope.resultState = $scope.ResultStates.Error;
              });
          }
        }, 200);

        $scope.$watch('searchString', function (newValue, oldValue) {
          if (!newValue) {
            previousSearchString = null;
          }

          if (!newValue && oldValue) {
            $scope.searchResults = [];
            $scope.resultState = $scope.ResultStates.Initial;
            $scope.uiState = $scope.UiStates.Idle;
          } else {
            doSearch();
          }
        });
      },

      link: function (scope, element) {
        scope.setKeyboardSelectionMode();

        var searchInputElement = $(element).find('input');

        KeyboardShortcutService.push({
          global: {
            'mod+l': {
              action: function (event) {
                event.preventDefault();

                scope.$apply(function () {
                  searchInputElement.focus();
                });
              },
              label: 'keyboard-shortcuts.focus-search-field.label'
            }
          }
        });
      }
    };
  });

export default COMPONENT_NAME;
